import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { LayoutGrid, CalendarDays, Users, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const links = [
  { to: "/relationships", label: "Relationship Dashboard", icon: LayoutGrid, testid: "nav-relationships" },
  { to: "/calendar", label: "Calendar & Timeline", icon: CalendarDays, testid: "nav-calendar" },
  { to: "/contacts", label: "Contacts Database", icon: Users, testid: "nav-contacts" },
];

export default function Layout() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen flex bg-slate-50">
      <aside className="w-64 fixed left-0 top-0 h-screen bg-white border-r border-slate-100 flex flex-col py-7 px-4 z-30">
        <div className="px-3 pb-5 border-b border-slate-100">
          <div className="font-logo text-2xl text-slate-900">Michael Rist</div>
          <div className="text-[10px] mt-0.5 uppercase tracking-[0.22em] text-slate-400 font-heading">
            Lender · CRM
          </div>
        </div>

        <nav className="mt-6 flex-1 space-y-1">
          {links.map(({ to, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium font-heading transition-colors ${
                  isActive
                    ? "bg-slate-900 text-white"
                    : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-auto pt-4 border-t border-slate-100">
          <div className="px-3 mb-2 text-xs text-slate-500 font-body truncate" data-testid="current-user-email">
            {user?.email}
          </div>
          <button
            onClick={logout}
            data-testid="logout-button"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors font-heading"
          >
            <LogOut className="w-4 h-4" />
            Sign out
          </button>
        </div>
      </aside>

      <main className="ml-64 flex-1 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
